import * as api from './index';

export function getMaterials(query) {
    const queryString = (new URLSearchParams(query)).toString();
    return api.get(`/materials?${queryString}`);
}

export function getMaterial(id) {
    return api.get(`/materials/${id}`);
}

export function createMaterial(material) {
    return api.post('/materials', material);
}

export function updateMaterial(material) {
    return api.patch(`/materials/${material.id}`, material);
}

export function softDeleteMaterial(material) {
    return api.del(`/materials/${material.id}/soft`);
}
